import React from 'react'
import { Col, Row, Spin } from 'antd'

const PageLoader = props => {
  return (
    <Row type="flex" justify="space-around" align="middle">
      <Col span={4}>
        <div className="spinner-wrapper">
          <Spin size="large" />
        </div>
      </Col>
    </Row>
  )
}

export default PageLoader
